import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Button } from '@/components/foundation/Button';

export interface EmptyStateAction {
  label: string;
  onClick?: () => void;
  href?: string;
}

export interface EmptyStateProps {
  title: string;
  description?: string;
  /** Optional hero icon (24px muted per SEDL §27). */
  icon?: ReactNode;
  /** Primary CTA — completes the I–T–A–C pattern. */
  primaryAction?: EmptyStateAction;
  className?: string;
}

export function EmptyState({
  title,
  description,
  icon,
  primaryAction,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'card-surface flex flex-col items-center justify-center px-6 py-16 text-center',
        className,
      )}
    >
      {icon ? (
        <div className="mb-4 flex h-12 w-12 items-center justify-center text-[var(--text-muted)]">
          {icon}
        </div>
      ) : null}
      <h2 className="text-lg font-semibold text-[var(--text-primary)]">{title}</h2>
      {description ? (
        <p className="mt-2 max-w-[65ch] text-secondary">{description}</p>
      ) : null}
      {primaryAction ? (
        <div className="mt-6">
          {primaryAction.href ? (
            <a href={primaryAction.href} className="btn-primary inline-block">
              {primaryAction.label}
            </a>
          ) : (
            <Button type="button" onClick={primaryAction.onClick}>
              {primaryAction.label}
            </Button>
          )}
        </div>
      ) : null}
    </div>
  );
}
